import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { compose, lifecycle, setPropTypes, defaultProps } from 'recompose'
import ReactTable from 'react-table'
import { numberFormat } from 'core/utilities'
import NumberFormat from 'react-number-format'
import { StdForm } from 'components'
import { DetailContainer, Cont, SContDetail, FooterCont, ItemSummaryRow, DpItemContainer } from './styled'
import { dpItemColumns } from './data'
import DownPaymentInformation from '../DownPaymentInformation'

const DownPaymentDetail = (props) => {
  const { dpDetail, valueForm } = props
  const items = dpDetail.downPaymentItems || []

  return (
    <StdForm title=''>
      <DownPaymentInformation dpDetail={dpDetail} />
      <DetailContainer>
        <Cont style={{ width: '100%' }}>
          <DpItemContainer>
            <ReactTable
              className='dpItems'
              data={items}
              columns={dpItemColumns}
              minRows={items.length > 10 ? 10 : items.length || 5}
              defaultPageSize={10}
              showPagination={items.length > 10}
            />
          </DpItemContainer>
          <FooterCont>
            <SContDetail>
            <ItemSummaryRow>
              <div className='title'>{` Withholding Tax ${dpDetail.withholdingTaxRate || ' 0 '} % `}:</div>
              <div className='summaryValue'>{numberFormat(((dpDetail.amount || 0) * (valueForm.withholdingTaxRate || 0) / 100), true)}</div>
              <div className='currency'>{dpDetail.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='title'>Vat {dpDetail.vatRate}%:</div>
              <div className='summaryValue'>{numberFormat(dpDetail.vatAmount, true)}</div>
              <div className='currency'>{dpDetail.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='itemSummaryLabel'>Net Amount:</div>
              <div className='summaryValue'>{numberFormat((dpDetail.netAmount || 0) - ((dpDetail.amount || 0) * (valueForm.withholdingTaxRate || 0) / 100), true)}</div>
              <div className='currency'>{dpDetail.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          </FooterCont>
        </Cont>
      </DetailContainer>

    </StdForm>

  )
}

const propTypes = {
  dpDetail: PropTypes.object,
}

const defaultProp = {
  dpDetail: {},
}

const mapStateToProps = state => {
  return {
    valueForm: getFormValues('formDP')(state),
  }
}

const mapDispatchToProps = {}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  setPropTypes(propTypes),
  defaultProps(defaultProp),
  lifecycle({
    componentDidMount() { },
    componentDidUpdate(prevProps) { }
  })
)

export default enhance(DownPaymentDetail)
